<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
                <b-row>
                    <b-col lg="4">
                        <span class="text-dark">
                            {{$t('sales_distribution_admin.year')}} : {{ yearNameById(item.fiscal_year_id) }}
                        </span>
                    </b-col>
                    <b-col lg="4">
                        <span class="text-dark">
                            {{$t('sales_distribution_admin.month')}} : {{ monthNameById(item.month) }}
                        </span>
                    </b-col>
                    <b-col lg="4">
                        <span class="text-dark">
                            {{$t('production_store.pro_category')}} : {{ item.category_id ? getCategoryName(item.category_id) : '' }}
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4">
                        <span class="text-dark">
                            {{ $t('production_store.target_id')}} : {{ item.target_id }}
                        </span>
                    </b-col>
                    <b-col lg="4">
                        <span class="text-dark">
                            {{ $t('production_store.target_date')}} : {{ item.target_date | dateFormat }}
                        </span>
                    </b-col>
                    <b-col lg="4">
                        <span class="text-dark">
                            {{ $t('sales_distribution_admin.target_amount')}} : {{ $n(item.approve_amount) }}
                        </span>
                    </b-col>
                </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { mapGetters } from 'vuex'
export default {
    name: 'FormLayout',
    props: ['item'],
    mounted () {
        core.index()
    },
    computed: {
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(year => year.status === 0)
        },
        monthList: function () {
          const montObj = this.productCommonObj.monthList
          return montObj.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
            } else {
              return { value: obj.value, text: obj.text_en }
            }
          })
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        }),
        currentLocale: function () {
            return this.$i18n.locale
        }
    },
    methods: {
        getCategoryName (Id) {
            const Obj = this.productCommonObj.productCategoryList.find(el => el.value === parseInt(Id))
            if (typeof Obj !== 'undefined') {
                return this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn
            }
            return ''
        },
        yearNameById (id) {
            const product = this.fiscalYearList.find(product => product.value === parseInt(id))
            if (this.$i18n.locale === 'bn') {
                return product.text
            } else {
               return product.text
            }
        },
        monthNameById (monthId) {
            const id = parseInt(monthId)
            const unit = this.monthList.find(month => month.value === id)
            return unit.text
        }
    }
}
</script>
